import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { protectedResourceMap } from '@commonConfig/msalb2c.config';
import { ProtectedResourceScopes } from '@commonNodeModules/@azure/msal-angular';
import { AuthenticationResult } from "@commonNodeModules/@azure/msal-browser";
import { MsalB2CService } from "@commonServices/msalb2c.service";
import { Minimatch } from "minimatch";
import { Observable, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { apiAccesses } from './msalb2c.config';
;

// TODO Interceptor entfernen wenn https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/3758 gefixt ist und msal Interceptor verwenden
@Injectable({
	providedIn: 'root'
})
export class MsalB2CInterceptor implements HttpInterceptor {
	constructor(
		private msalB2CService: MsalB2CService
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.url.startsWith('/assets/') || !this.msalB2CService.isLoggedIn()) {
			return next.handle(req);
		}

		const scopes = this.getScopesForEndpoint(req.url);
		if (!scopes || scopes.length === 0) {
			return next.handle(req);
		}

		// Note: For MSA accounts, include openid scope when calling acquireTokenSilent to return idToken
		return from(this.msalB2CService.acquireTokenSilent(scopes as any))
			.pipe(
				catchError(() => from(this.msalB2CService.logout())),
				switchMap((result: AuthenticationResult) => {
					const headers = req.headers
						.set('Authorization', `Bearer ${result.accessToken}`)

					const requestClone = req.clone({ headers });
					return next.handle(requestClone);
				})
			)

	}

	private getScopesForEndpoint(endpoint: string): (string | ProtectedResourceScopes)[] {
		const protectedResourcesArray = Array.from(protectedResourceMap(apiAccesses).keys());
		const keyMatchesEndpointArray = protectedResourcesArray.filter(key => {
			const minimatch = new Minimatch(key);
			return minimatch.match(endpoint) || endpoint.indexOf(key) > -1;
		});

		// process all protected resources and send the first matched resource
		if (keyMatchesEndpointArray.length > 0) {
			const keyForEndpoint = keyMatchesEndpointArray[0];
			if (keyForEndpoint) {
				return protectedResourceMap(apiAccesses).get(keyForEndpoint);
			}
		}

		return null;
	}
}
